import InputContainer from '~COMPONENTS/formInputs/containers/InputContainer';
import TextInput from '~COMPONENTS/formInputs/TextInput';
import { TranslatedCopy } from '../intl/TranslatedCopy';

const getSizeChartTableColumns = (id, hasPreviousReturnQuantity, displayOnly) => [
  {
    header: <TranslatedCopy id='gridwall.filters.size' />,
    id: 'size',
    cell: size => {
      return <span className='text-color-primary'>{size.sizeDisplay || size.code}</span> || null;
    }
  },
  {
    header: <TranslatedCopy id='orderreturns.sizetable.returnableQuantity' />,
    id: 'quantity',
    cell: size => {
      return <span className='text-color-secondary'>{size.returnableQuantity}</span> || null;
    }
  },
  ...(hasPreviousReturnQuantity
    ? [
        {
          header: <TranslatedCopy id='orderreturns.sizetable.availableToReturn' />,
          id: 'prevReturnQuantity',
          cell: size => {
            return <span className='text-color-secondary'>{size.previouslyReturnedQuantity}</span> || null;
          }
        }
      ]
    : []),
  {
    header: <TranslatedCopy id='global.total' />,
    id: 'total',
    cell: (size, { onChange }) => {
      return displayOnly ? (
        <span className='text-color-secondary'>{size.quantity === 0 ? '' : size.quantity}</span>
      ) : (
        <InputContainer className='text-color-secondary' error={!!size.hasError} customStyles={{ marginTop: '-20px' }}>
          <TextInput
            name={`${id}__${size.code}`}
            onChange={val => onChange(size.code, val)}
            type='text'
            value={size.quantity === 0 ? '' : size.quantity}
          />
        </InputContainer>
      );
    }
  }
];

export default getSizeChartTableColumns;
